import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { Tooltip } from 'src/common/components/tooltip';
import { useIsInRight } from 'src/utils/right-utils';
import { CommentTabIndex, setCommentListIndex } from 'src/views/comments/page-resolved-discussions';
import { useDrawerOpenState, useToggleDrawer } from '../drawer/shared';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const PageCommentButton: FC<{ className?: string }> = ({ className }) => {
  const { t } = useAppTranslation();
  const [drawState] = useDrawerOpenState();
  const toggleDrawer = useToggleDrawer();
  const isInRight = useIsInRight();
  const hover =
    (isInRight && drawState === 'page-resolved-discussions-right') ||
    (!isInRight && drawState === 'page-resolved-discussions');
  return (
    <Tooltip
      popup={drawState ? t('views.header.close_comment_list') : t('views.header.view_comment_list')}
      className={cx(
        'p-1 flex items-center justify-center animate-hover',
        hover && 'bg-black_006',
        className
      )}
      onClick={() => {
        setCommentListIndex(CommentTabIndex.UN_RESOLVE_COMMENT);
        toggleDrawer('page-resolved-discussions');
      }}
    >
      <Icon name={'IcComment'} size="middle" />
    </Tooltip>
  );
};
